import React from 'react'
import { useTranslation } from 'react-i18next'
import { MappingLevel } from '../types'
import { getMappingLabel, MAPPING_LEVELS } from '../utils/mappingLevel'

// Descriptive text only - the ●/○/— symbols themselves come from getMappingLabel (mappingLevel.ts),
// the single source of truth for them. Keeping symbols out of the translated strings avoids
// repeating them in every locale file.
const LEGEND_DESCRIPTION_FALLBACK: Record<MappingLevel, string> = {
  complete: 'asiakas + toimittaja kunnossa',
  customerOnly: 'vain asiakas linkitetty',
  supplierOnly: 'vain toimittaja linkitetty',
  missing: 'ei linkitystä',
  self: 'oma itse'
}

const MappingLegend: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div style={{ display: 'flex', gap: 20, fontSize: 11, color: '#666', marginTop: 12 }}>
      {MAPPING_LEVELS.map(level => (
        <span key={level} style={level === 'missing' ? { color: '#c0392b' } : undefined}>
          {getMappingLabel(level)} ={' '}
          {t(`groupCustomerMapping:mappingLevel-${level}`, LEGEND_DESCRIPTION_FALLBACK[level])}
        </span>
      ))}
    </div>
  )
}

export default MappingLegend
